module.exports = __webpack_public_path__ + "static/b77aaabc.newYearNumberFlower1.png";